import { ThemeUICSSObject } from '@apia/theme';
import container from './container';
import card from './card';
import logo from './logo';
import spinner from './spinner';
import langs from './langs';
/* IMPORT HERE */

const login: ThemeUICSSObject = {
  container,
  card,
  logo,
  langs,
  spinner,
  /* PREPEND HERE */
};

export default login;
